var _defs, _ellipse, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _rect2, _rect3, _line, _line2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#C8A55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C7E3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldSoft5",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C8A55B",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5C77D",
    stopOpacity: 0.06
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 158,
    rx: 72,
    ry: 8,
    fill: "url(#gold5)",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 150 Q52 128 76 140 Q100 152 124 132 Q148 112 172 140 L172 160 L28 160 Z",
    fill: "url(#goldSoft5)",
    stroke: "url(#gold5)",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 60,
    r: 16,
    fill: "url(#goldSoft5)",
    stroke: "url(#gold5)",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 58,
    r: 13,
    fill: "currentColor",
    fillOpacity: 0.06
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 52,
    r: 1.5,
    fill: "url(#gold5)",
    fillOpacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 1,
    fill: "url(#gold5)",
    fillOpacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 72,
    r: 1,
    fill: "url(#gold5)",
    fillOpacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 38,
    r: 1.5,
    fill: "url(#gold5)",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 94,
    width: 6,
    height: 58,
    rx: 2,
    fill: "url(#gold5)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 98,
    width: 52,
    height: 16,
    rx: 4,
    fill: "url(#goldSoft5)",
    stroke: "url(#gold5)",
    strokeWidth: 1.5,
    transform: "rotate(-3 100 106)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 118,
    width: 48,
    height: 16,
    rx: 4,
    fill: "url(#goldSoft5)",
    stroke: "url(#gold5)",
    strokeWidth: 1.5,
    transform: "rotate(4 104 126)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 106,
    x2: 114,
    y2: 105,
    stroke: "url(#gold5)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeOpacity: 0.5,
    transform: "rotate(-3 97 106)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 126,
    x2: 118,
    y2: 127,
    stroke: "url(#gold5)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeOpacity: 0.5,
    transform: "rotate(4 102 126)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 106,
    y: 129,
    fontFamily: "serif",
    fontSize: 11,
    fontWeight: "bold",
    fill: "url(#gold5)",
    fillOpacity: 0.7,
    transform: "rotate(4 104 126)"
  }, "?")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound404);
export default __webpack_public_path__ + "static/media/not-found-404.152559b22012c90ffb375ad8a4dbee2f.svg";
export { ForwardRef as ReactComponent };